export const FLOW_STATUS = {
  LIVE: "Live",
  DRAFT: "Draft",
  PENDING: "Pending",
  ARCHIVED: "Archived",
  DELETED: "Deleted"
};

export const SUB_FLOW_TYPES = {
  FORMVIEW: "FormView",
  REPORT: "Report",
  CASEVIEW: "CaseView",
  ANALYTICS_REPORT: "AnalyticsReport"
};

export const REPORT_VIEW_TYPES = {
  TABULAR: "Tabular",
  PIVOT: "Pivot"
};

export const CHART_VIEW_TYPE = {
  AUTOCHART: "AutoChart",
  AREACHART: "AreaChart",
  AREALAYERCHART: "AreaLayerChart",
  BARROWCHART: "BarrowChart",
  BARCOLUMNCHART: "BarColumnChart",
  LINECHART: "LineChart",
  COMPOSEDCHART: "ComposedChart",
  BUBBLECHART: "BubbleChart",
  PIECHART: "PieChart",
  DOUGHNUTCHART: "DoughnutChart",
  BARSTACKEDROWCHART: "BarStackedRowChart",
  BARSTACKEDCOLUMNCHART: "BarStackedColumnChart",
  HUNDREDPERCENTBARSTACKEDCOLUMNCHART: "HundredPercentBarStackedColumnChart",
  HUNDREDPERCENTBARSTACKEDROWCHART: "HundredPercentBarStackedRowChart"
};
